import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import trTranslations from './trCustom.json';
import enTranslations from './enCustom.json';

i18n
  .use(LanguageDetector) // Tarayıcı dil algılayıcısını kullanıyoruz
  .use(initReactI18next) // React ile i18next'i başlatıyoruz
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      tr: {
        translation: trTranslations,
      },
    },
    fallbackLng: 'en', // Dil algılanamazsa varsayılan dil
    interpolation: {
      escapeValue: false, // React zaten XSS koruması sağlar
    },
    detection: {
      order: ['localStorage', 'navigator'], // Dil algılama sırası
      caches: ['localStorage'], // Hangi yöntemle dil saklanacak
    },
  });

export default i18n;
